import { render, staticRenderFns } from "./RightTable3.vue?vue&type=template&id=07874245&scoped=true&"
import script from "./RightTable3.vue?vue&type=script&lang=js&"
export * from "./RightTable3.vue?vue&type=script&lang=js&"
import style0 from "./RightTable3.vue?vue&type=style&index=0&id=07874245&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07874245",
  null
  
)

export default component.exports